const API_URL = process.env.REACT_APP_API_URL
  || 'https://web-production-ef813.up.railway.app';

export default API_URL;
